import { Modal, Form } from "antd";
import PlanFormFields, { buildPlanPayload } from "./PlanFormFields";

const CreateSubscriptionPlanModal = ({ visible, loading, onSubmit, onClose }) => {
    const [form] = Form.useForm();

    const handleFinish = (values) => {
        onSubmit(buildPlanPayload(values));
    };

    const handleAfterClose = () => {
        form.resetFields();
    };

    return (
        <Modal
            title="Create billing plan"
            open={visible}
            onCancel={onClose}
            onOk={() => form.submit()}
            confirmLoading={loading}
            width={840}
            afterClose={handleAfterClose}
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleFinish}
                initialValues={{
                    status: "active",
                    display_order: 0,
                    is_default: false,
                    is_featured: false,
                    limits: {
                        ai_requests_monthly: { unlimited: false, value: 1000 },
                        polar_summaries_monthly: { unlimited: true },
                        ga4_properties: { unlimited: false, value: 1 },
                        invited_members: { unlimited: false, value: 0 },
                        replay_sessions_month: { unlimited: true },
                    },
                }}
            >
                <PlanFormFields isEdit={false} />
            </Form>
        </Modal>
    );
};

export default CreateSubscriptionPlanModal;
